import $ from 'jquery'

$(document).on('click', '.js-ga-event', ({ currentTarget }) => {
  const { eventCategory, eventAction, eventLabel } = currentTarget.dataset
  if (window.ga !== undefined) {
    window.ga('send', 'event', eventCategory, eventAction, eventLabel)
  }
})
